import React, { createContext, useState, useEffect } from 'react';
import { forgetShowSession } from '../lib/showSession';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [userToken, setUserToken] = useState(localStorage.getItem('token') || null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            setUserToken(token);
        }
    }, []);

    const login = (token) => {
        forgetShowSession();
        setUserToken(token);
        localStorage.setItem('token', token);
    };

    const logout = () => {
        forgetShowSession();
        setUserToken(null);
        localStorage.removeItem('token');
    };

    return (
        <AuthContext.Provider value={{ userToken, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
